<template>
  <div class="xianxia-xingwei-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle"  :contentWidth=13>
      <div class="single-line single-time">
        <div class="chart-content">
          <ol class="tabli">
            <li :class="{ current: tableTab == 0 }" @click="tableTab = 0">近一月</li>
            <li :class="{ current: tableTab == 1 }" @click="tableTab = 1">近三月</li>
            <li :class="{ current: tableTab == 2 }" @click="tableTab = 2">近一年</li>
            <li :class="{ current: tableTab == 3 }" @click="tableTab = 3">其他时间</li>
          </ol>
        </div>
      </div>
      <div class="geyebili single-line" style="min-height: 0rem">
        <div class="content">
          <ol class="tab">
            <li
              class="targetli"
              v-for="(item, index) in tabList"
              :key="index"
              :class="{ current: curTab == index }"
              @click="curTab = index"
            >
              {{ item }}
            </li>
          </ol>
        </div>
      </div>

      <div class="tingliushijian single-line">
        <!--<div class="chart-title">游客停留时间</div>-->
        <div class="chart-content">

          <Radar id="KoubeiPingjiaFenshuRadar" :chartData="KoubeiPingjiaFenshuRadarData" :legendRight="200"/>

          <!--<div class="chart-title" @click="$store.commit('setSpotModalShow')">-->
          <!---->
          <!--</div>-->
          选择或更换景区 >
        </div>
      </div>

      <div class="tingliushijian single-line">
        <div class="chart-title">典型景区口碑评价分数图</div>
        <ul class="comment-tab">
          <li v-for="(item,index) in liList" v-on:click="addClass(index)" v-bind:class="{
         active:index==current}">{{item.title}}</li>
        </ul>
        <!--<div class="content">
          <ol class="tab">
            <li
                    v-for="(item, index) in tabList2"
                    :key="index"
                    :class="{ current: curTab2 == index }"
                    @click="curTab2 = index"
            >
              {{ item }}
            </li>
          </ol>
        </div>-->
        <div class="chart-content">
    <!--      <div class="chart-title" @click="$store.commit('setSpotModalShow')">
            选择或更换景区
          </div>-->

          <SingleBar
            id="xiaofeiqianli"
            xy="x"
            :barWidth="40"
            :interval='"0"'
            :showPercentage =false
            :chartData="JingquKoubeiPingjiaData"
          />
        </div>
      </div>
      <div class="tingliushijian single-line">
        <div class="chart-title">游客评分排名</div>
        <div class="chart-content">
          <YoukePingfenPaiming id="youkepingfenpaiming"
                               :chartData ="YoukePingfenPaimingData"
          />
        </div>
      </div>

      <div class="shengliangqushiduijie single-line">
        <div class="chart-title">声量趋势堆叠图</div>
        <div class="chart-content" >
          <ShengliangQushiDuidie id="koubeixiangqingshengliangqushi"  :chartData="ShengLiangQushiDuidieData"
                         v-if="ShengLiangQushiDuidieData" />
         </div>
      </div>

      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";
import SingleBar from "@/components/Echarts/SingleBar.vue";

import Radar from "@/components/Echarts/Radar.vue";

import YoukePingfenPaiming from "@/components/Echarts/JingquKoubei/YoukePingfenPaiming.vue";
import ShengliangQushiDuidie from "@/components/Echarts/JingquKoubei/HomeBottomLine.vue";

export default {
  name: "XianxiaXingweiFenxiDetail",
  components: {
    ChildModal,
    SingleBar,
    YoukePingfenPaiming,
    ShengliangQushiDuidie,
    Radar,

  },
  props: {},
  data() {
    return {
        ShengLiangQushiDuidieData:null,
        JingquKoubeiPingjiaData: null,
        YoukePingfenPaimingData:null,
        KoubeiPingjiaFenshuRadarData:null,
        tableTab: 0,

        geyebili_fenlei: 0,
      tingliushijian_fenlei: 1,
      retu_month: 7,
      zhejiang: [
        "杭州",
        "湖州",
        "绍兴",
        "宁波",
        "嘉兴",
        "丽水",
        "台州",
        "温州",
        "金华",
        "衢州",
        "舟山"
      ],
      curCity: "杭州",
      cityCenter: [120.215519, 30.253073],
      zhusuretuData: [
        [120.215519, 30.253073, 50],
        [120.336325, 30.264189, 80],
        [120.464863, 30.258372, 60],
        [120.574215, 30.272895, 60],
        [120.637996, 30.209721, 60],
        [120.601811, 30.252331, 99],
        [120.618449, 30.230813, 60],
        [120.680575, 30.298937, 54],
        [120.650751, 30.251395, 55],
        [120.694373, 30.253859, 40]
      ],
      cityListShow: false,
      curTab: 0,
      tabList: [
        "客流热度",
        "5A",
        "4A",
        "3A及以下",
        "山水",
        "博物馆",
        "海岛",
        "主题公园"
      ],
      curTab2: 2,
      tabList2: [
        "综合",
        "交通",
        "服务",
        "安全",
        "消费",
        "卫生",
        "体验",
        "配套",
        "景观"
      ],
        mapTitleData: {
            title: '',
            tab: ['近一月', '近三月','近一年','其他时间']
        },

        current:0,
        liList:[
            {title:'综合'},
            {title:'交通'},
            {title:'服务'},
            {title:'安全'},
            {title:'消费'},
            {title:'卫生'},
            {title:'体验'},
            {title:'配套'},
            {title:'景观'}
        ],
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs.pointer2.style.transform = "rotate(90deg)";
    // }, 500);

    // 请求口碑评价分数
    fetch("/data/JingquKoubei/JingquKoubeiDetail/KoubeiPingjiaFenshu.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.JingquKoubeiPingjiaData = json.data;
      });
      // 请求声量趋势堆叠图
      fetch("/data/JingquKoubei/ShengLiangQushiDuidie.json")
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.ShengLiangQushiDuidieData = json.data;
          });
      // 请求游客评分排名
      fetch("/data/JingquKoubei/JingquKoubeiDetail/YoukePingfenPaiming.json")
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.YoukePingfenPaimingData = json.data;
          });
      // 请求游客评分排名
      fetch("/data/JingquKoubei/JingquKoubeiDetail/YoukePingfenPaiming.json")
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.YoukePingfenPaimingData = json.data;
          });
// 请求口碑评价分数雷达图
      fetch("/data/JingquKoubei/JingquKoubeiDetail/KoubeiPingjiaFenshuRadar.json")
          .then(response => {
              return response.json();
          })
          .then(json => {
              this.KoubeiPingjiaFenshuRadarData = json.data;
          });

  },
  methods: {
      addClass(index){
          this.current=index
      }
  }
};
</script>

<style scoped lang="less">
.geyebili {
  padding: 0 1rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.05rem !important;
  .chart-content {
    ol {
      width: 44%;
    }
    ul {
      margin: 1rem auto 0;
      position: relative;
      .yibiao1 {
        float: left;
      }
      .yibiao3 {
        float: right;
      }
      .yibiao2 {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -20%) scale(1.5);
      }
      li {
        width: 2.28rem;
        height: 2.28rem;
        position: relative;
        .info {
          margin-top: 0.12rem;
          width: 100%;
          text-align: center;
          .bili {
            color: #ff553e;
          }
        }
        .bg {
          width: 2.28rem;
          height: 1.14rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .pointer {
          transition: all 0.4s;
          width: 2.28rem;
          height: 2.28rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan_pointer.png)
            no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(0deg);
        }
      }
    }
  }
}


.content {
  overflow: hidden;
  width: 100%;
  height: 92.5%;
  box-sizing: border-box;
  .tab {
    width: 9.4rem;
    height: 0.24rem;
    margin: 0 auto 0.26rem;
    li {
      width: 12.5%;
      height: 100%;
      float: left;
      color: #fff;
      background: url(../../assets/spot_tab_bg.png);
      background-size: 100% 100%;
      cursor: pointer;
    }
    .current {
      background: url(../../assets/spot_tab_bg_.png);
      background-size: 100% 100%;
    }
  }
}

.left-content {
  transition: 0.3s;
  width: 4.24rem;
  height: 84%;
  left: 0.6rem;
  padding-left: 1.5rem;
  margin-bottom: 0.2rem;
  top: 1.24rem !important;
  overflow: hidden;

  .tabli {
    width: 3.5rem;
    height: 0.3rem;
    margin: 0 auto 0.16rem;
    > li {
      float: left;
      width: 20%;
      height: 0.3rem;
      line-height: 0.3rem;
      cursor: pointer;
    }
    .current {
      color: @light-blue;
      border-bottom: 1px solid @light-blue;
      background-image: linear-gradient(
              to top,
              rgba(0, 84, 178, 0.4),
              rgba(34, 84, 178, 0.05)
      );
    }
  }
}

.comment-tab{
  text-align: left;
  width: 9.9rem;
  margin: 0 auto 0.2rem;
  li{
    width: 0.9rem;
    margin: 0 0.1rem;
    color: #fff;
    background: #006cb5;
    display: inline-block;
    text-align: center;
    font-size: 0.14rem;
    cursor: pointer;
    &.active{
      background: #00cdff;
    }
  }
}
.shengliangqushiduijie .chart-content {
  width: 80%;
  height: 240px;
}
.single-time {
  min-height: 0 !important;
  margin-bottom: 0.2rem !important;
  .chart-content {
    ol {
      width: 40%;
      li {
        width: 25%;
      }
    }
  }
}
</style>
